<template>
  <RF-Dialog v-if="time !== ''" v-show='time >= 1 && mostrar === true'
  :cpntStatus='statusGeral'
  :cpntRegistro='[]'
  :cpntLargura='"880px"'
  :cpntTitulo="'OPS! Alguns campos já possuem informação, selecione os que deseja substituir:'"

  :cpntOnFecharDialog='onFecharVisualizacao'>
    <template slot='conteudo' v-if="Object.keys(tabela).length >= 1">
      <!-- <ul class="list-group" style="width: 680px; margin: 0px auto;">
        <li class="list-group-item"><i aria-hidden="true" class="fa fa-angle-double-right"></i>&nbsp;<b style="text-decoration: underline;">Atenção</b></li>
        <li class="list-group-item" style="padding-left: 25px;">Selecione apenas as colunas que deseja atualizar em seu formulário.</li>
        <li class="list-group-item" style="padding-left: 25px;">As linhas com a cor AMARELA, mostra que existe diferença(s) entre os dados atuais e os novos dados.</li>
      </ul> -->

      <RF-Tabela style="text-align: center; margin: 25px 0px 15px 0px;"
        :data-time='time'

        :cpntTime='time'
        :cpntId='tabela.id'
        :cpntStatus='tabela.status'
        :cpntButtonImprimir='tabela.acoes.btImprimir'
        :cpntButtonImprimirOculta='tabela.acoes.btImprimirOculta'
        :cpntButtonAtualizar='tabela.acoes.btAtualizar'
        :cpntFraseTop='tabela.fraseTop'
        :cpntInfoTabela='tabela.infoTabela'
        :cpntColuna='tabela.coluna'
        :cpntLinha='tabela.linha'
        :cpntCountAll='tabela.countAll'
        :cpntColspan='tabela.colspan'
        :cpntButtonsAcoes='tabela.acoes.buttons'
        :cpntMper='tabela.mper'
        :cpntPagina='tabela.pagina'
        :cpntCheckboxEditar='tabela.checkboxEditar'
        :cpntFieldsEditar='tabela.acoes.fields'

        :cpntOnCheckboxAtualiza='onCheckboxAtualiza'
        :ref='tabela.id'
      ></RF-Tabela>

      <div style="text-align: center; margin: 25px 0px 15px 0px;" v-if="Object.keys(buttons).length >= 1" >
        <RF-Button style="margin: 0px 5px;" v-for='(button, index) in buttons' :key="index"
          :data-time='time'

          :cpntStatus='button.status' 
          :cpntId='button.id' 
          :cpntTexto='button.texto' 
          :cpntClass='button.class'
          :cpntMostrar='button.mostrar'
          :cpntTabIndex='button.tabIndex'

          @onClickButton='button.onClick()'
        ></RF-Button>
      </div>
    </template>
  </RF-Dialog>
</template>

<style>
  #tab-tab-check-ret-api-busca > tbody > tr > td {
    /* vertical-align: top; */
  }
  #tab-tab-check-ret-api-busca > tbody > tr > td.tab-tab-check-ret-api-busca-td-tipo {
    width: 130px !important;
  }
  #tab-tab-check-ret-api-busca > tbody > tr > td.tab-tab-check-ret-api-busca-td-acao {
    width: 230px !important;
    padding: 8px 0px 4px 0px;
    border-right: none !important;
    border-left: none !important;
  }
    #tab-tab-check-ret-api-busca > tbody > tr > td.tab-tab-check-ret-api-busca-td-acao > div > div {
      margin: 0px;
      padding: 0px;
    }
    #tab-tab-check-ret-api-busca > tbody > tr > td.tab-tab-check-ret-api-busca-td-acao > .rf-toogles--2 > div > button.rf-toogles-false:not(:disabled) {
      color: var(--color-base-02);
      opacity: 1;
    }
    #tab-tab-check-ret-api-busca > tbody > tr > td.tab-tab-check-ret-api-busca-td-acao .btn {
      padding: 2px 7px;
    }
  #tab-tab-check-ret-api-busca > tbody > tr > td.tab-tab-check-ret-api-busca-td-valueForm {
    border-right: none !important;
  }
  #tab-tab-check-ret-api-busca > tbody > tr > td.tab-tab-check-ret-api-busca-td-valueApi {
    border-left: none !important;
  }
  #tab-tab-check-ret-api-busca > tbody > tr.rf-busca-api-tipo-0 > td.tab-tab-check-ret-api-busca-td-valueForm {
    font-weight: bold;
  }
  #tab-tab-check-ret-api-busca > tbody > tr.rf-busca-api-tipo-1 > td.tab-tab-check-ret-api-busca-td-valueForm,
  #tab-tab-check-ret-api-busca > tbody > tr.rf-busca-api-tipo-1 > td.tab-tab-check-ret-api-busca-td-valueApi {
    font-weight: bold;
  }
  #tab-tab-check-ret-api-busca > tbody > tr.rf-busca-api-tipo-2 > td.tab-tab-check-ret-api-busca-td-valueApi {
    font-weight: bold;
  }

  input.radio-check-value-api {
    margin-left: 5px !important;
    margin-right: 2px !important;
    vertical-align: -2px !important;
  }
</style>

<script>
  export default {
    props: {
      cpntTipo: {
        required: true,
        type: String
      },
      cpntDadosApi: {
        required: true,
        type: Object
      },
      cpntDadosForm: {
        required: true,
        type: Object
      },
      cpntCampos: {
        required: true,
        type: Array
      },
      cpntOnFecharFormulario: {
        required: true
      }
    },
    data: function () {
      return {
        time: '',
        mostrar: true,
        statusGeral: '',
        tabela: {},
        checkbox: { keyForm: [] },
        buttons: {},
        dadosApi: {},
        buscarCnae: []
      }
    },
    mounted: function () {
      this.iniciar()
    },
    methods: {
      iniciar: function () {
        // SETA O STATUS GERAL DA PAGINA
        this.statusGeral = 'carregando'

        // LIMPA OS DADOS EXISTENTES NA API
        this.dadosApi = {}

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()

        // DESTROI O QTIP SE ELE EXISITR
        $('.radio-check-value-api').qtip('destroy', true)

        // CHAMA A FUNÇÃO PARA CRIAR A TABELA DE VERIFICAÇÃO
        this.tratarRetornoBuscaCNPJ(this.criarTabelaVerificacao)
      },
      tratarRetornoBuscaCNPJ: function (callback = null) {
        // PEGA OS DADOS RECEBIDOS DA API
        this.dadosApi = [ '', null, undefined ].indexOf(this.cpntDadosApi) !== -1 ? {} : this.cpntDadosApi

        if (Object.keys(this.dadosApi).length >= 1) {
          // VERIFICA SE O CAMPO j_ie_regime FOI RECEBIDO
          if ([ undefined ].indexOf(this.cpntDadosApi.j_ie_regime) === -1) {
            // CARREGA OS DADOS DO JSON RECEBIDO
            if ([ '', null ].indexOf(this.cpntDadosApi.j_ie_regime) === -1 && typeof this.cpntDadosApi.j_ie_regime === 'string') {
              this.cpntDadosApi.j_ie_regime = JSON.parse(this.cpntDadosApi.j_ie_regime)
            } else {
              this.cpntDadosApi.j_ie_regime = []
            }
          }
        }

        // VERIFICA SE FOI RECEBIDO UMA FUNÇÃO CALLBACK
        if (callback !== null) {
          callback()
        }
      },
      criarTabelaVerificacao: function () {
        var self = this

        // SETA O STATUS PARA TABELA
        self.statusGeral = ''

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        self.time = new Date().getTime()

        self.tabela = {
          status: 'carregando',
          montarTabelaCompleta: false,
          id: 'tab-check-ret-api-busca',
          coluna: [],
          linha: []
        }

        var valor = ''

        self.tabela.coluna = [
          { mPer: 2, chave: 'tipo', nome: 'Tipo' },
          { mPer: 2, chave: 'valueForm', nome: 'Valor Atual' },
          { mPer: 2, chave: 'acao', nome: 'Ação' },
          { mPer: 2, chave: 'valueApi', nome: 'Valor Novo' }
        ]

        self.tabela.contaValorBranco = 0

        for (var key in self.cpntCampos) {
          var linha = {}

          linha.tipo = self.cpntCampos[key].nome
          linha.campo = self.cpntCampos[key].keyForm

          linha.acao = [
            {
              tamanho: 2,
              tipo: 'toggles--2',
              nome: '',
              value: '2',
              options: [
                { id: '0', nome: 'Manter', disabled: false },
                { id: '1', nome: 'Mesclar', disabled: false },
                { id: '2', nome: 'Substituir', disabled: false }
              ],
              keyValue: 'id',
              keyMostra: [ 'nome' ],
              mostrar: true,
              onChange: function (value, id) {
                self.onChangeValueTabela(value, id)
              }
            }
          ]

          if (self.cpntCampos[key].hasOwnProperty('converteForm')) {
            switch (self.cpntCampos[key].converteForm.tipo) {
              case 'boolean':
                linha.valueForm = [ true, "true", 1, '1' ].indexOf(self.cpntDadosForm[self.cpntCampos[key].keyForm].value) !== -1 ? self.cpntCampos[key].converteForm.nameTrue : self.cpntCampos[key].converteForm.nameFalse
                break

              case 'radio':
                break

              case 'cnae':
                // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
                self.time = new Date().getTime()

                // ORDENA O VETOR COM OS PACOTES DISPONIVEIS
                self.cpntDadosForm[self.cpntCampos[key].keyForm].aRamIds = self.cpntDadosForm[self.cpntCampos[key].keyForm].aRamIds.sort(function (a, b) {
                  return a < b ? -1 : a > b ? 1 : 0
                })

                linha.valueForm = [
                  {
                    tipo: 'tabela-2',
                    colqtip: {},
                    montarTabelaCompleta: false,
                    id: 'tab-check-ret-api-busca-cnae-1',
                    coluna: [
                      { mPer: 3, chave: 'cnae', nome: 'Cnae' }
                      // { mPer: 3, chave: 'nome', nome: 'Descrição' }
                      // { mPer: 3, chave: 'acao', nome: 'Principal' }
                    ],
                    linha: [],
                    valores: self.cpntDadosForm[self.cpntCampos[key].keyForm]
                  }
                ]
                self.buscarCnae = self.buscarCnae.concat(self.cpntDadosForm[self.cpntCampos[key].keyForm].aRamIds)
                break

              case 'cidade':
              case 'modelo':
              case 'marca':
                var option = self.cpntDadosForm[self.cpntCampos[key].keyForm].options.filter(item => item[self.cpntCampos[key].converteForm.keyValue] === self.cpntDadosForm[self.cpntCampos[key].keyForm].value)

                if (option.length >= 1) {
                  linha.valueForm = option[0][self.cpntCampos[key].converteForm.keyMostra]
                } else {
                  linha.valueForm = ''
                }
                break

              default:
                linha.valueForm = '-'
                break
            }
          } else if (self.cpntDadosForm.hasOwnProperty(self.cpntCampos[key].keyForm)) {
            linha.valueForm = self.cpntDadosForm[self.cpntCampos[key].keyForm].value
          } else {
            linha.valueForm = '-'
          }

          if (self.cpntCampos[key].hasOwnProperty('converteApi')) {
            switch (self.cpntCampos[key].converteApi.tipo) {
              case 'boolean':
                linha.valueApi = self.cpntDadosApi[self.cpntCampos[key].keyApi] === true ? self.cpntCampos[key].converteApi.nameTrue : self.cpntCampos[key].converteApi.nameFalse
                break

              case 'radio':
                var dados = self.cpntDadosApi[self.cpntCampos[key].keyApi]
                
                //   linha.valueApi = dados[0].IE
                // } else {
                  // }
                linha.valueApi = ''
                for (var keyDados in dados) {
                  if (dados.length !== 1) {
                    linha.valueApi += "<input type='radio' name='radio-check-value-api-" + self.cpntCampos[key].keyApi + "' class='radio-check-value-api' value='" + dados[keyDados].IE + "' />"
                  }
                  
                  linha.valueApi += "<span class='radio-check-value-api' title='"
                  for (var chave in dados[keyDados]) {
                    if ([ 'number', 'string' ].indexOf(typeof dados[keyDados][chave]) !== -1) {
                      linha.valueApi += chave + ": " + dados[keyDados][chave] + "<br/>";
                    } else {
                      for (var chave2 in dados[keyDados]) {
                        if ([ 'number', 'string' ].indexOf(typeof dados[keyDados][chave][chave2]) !== -1) {
                          linha.valueApi += chave2 + ": " + dados[keyDados][chave][chave2] + "<br/>";
                        }
                      }
                    }
                  }
                  linha.valueApi += "'>" + dados[keyDados].IE + "</span><br/>"
                }
                break

              case 'cnae':
                linha.valueApi = ''
                if (self.cpntDadosApi[self.cpntCampos[key].keyApi] !== '' && self.cpntDadosApi[self.cpntCampos[key].keyApi] !== null) {
                  var cnaes = JSON.parse(self.cpntDadosApi[self.cpntCampos[key].keyApi])
                  // ORDENA O VETOR COM OS PACOTES DISPONIVEIS
                  cnaes.aRamIds = cnaes.aRamIds.sort(function (a, b) {
                    return a < b ? -1 : a > b ? 1 : 0
                  })

                  if (cnaes.hasOwnProperty('aRamIds')) {
                    linha.valueApi = [
                      {
                        tipo: 'tabela-2',
                        colqtip: {},
                        montarTabelaCompleta: false,
                        id: 'tab-check-ret-api-busca-cnae-2',
                        coluna: [
                          { mPer: 3, chave: 'cnae', nome: 'Cnae' }
                          // { mPer: 3, chave: 'nome', nome: 'Descrição' }
                          // { mPer: 3, chave: 'acao', nome: 'Principal' }
                        ],
                        linha: [],
                        valores: cnaes
                      }
                    ]
                    self.buscarCnae = self.buscarCnae.concat(cnaes.aRamIds)
                  }
                }
                break

              case 'socio':
                valor = JSON.parse(self.cpntDadosApi[self.cpntCampos[key].keyApi])

                if (valor.length >= 1) {
                  valor = valor[0].nome.trim()
                } else {
                  valor = '-'
                }

                linha.valueApi = valor.trim()
                break

              case 'divide':
                valor = self.cpntDadosApi[self.cpntCampos[key].keyApi].split('/')

                if (valor.hasOwnProperty(self.cpntCampos[key].converteApi.posicao)) {
                  valor = valor[self.cpntCampos[key].converteApi.posicao].trim()

                  valor.trim()
                  valor = valor.replace(/\D/g, '')
                  valor = valor.replace(/^(\d{2})(\d)/g, '($1)$2')
                  valor = valor.replace(/(\d)(\d{4})$/, '$1-$2')
                  linha.valueApi = valor.trim()
                } else {
                  linha.valueApi = '-'
                }
                break

              case 'ano-veiculo':
                // converteApi: { tipo: 'ano-veiculo', keys: { anoModelo: 'anoModelo', anoFabrica: 'ano' } }
                var valorModelo = self.cpntDadosApi[self.cpntCampos[key].converteApi.keys.anoModelo].toString()
                var valorFabrica = self.cpntDadosApi[self.cpntCampos[key].converteApi.keys.anoFabrica].toString()

                // DEIXA O ANO DO VEICULO COM APENAS 2 DIGITOS
                valorModelo = valorModelo.length > 2 ? valorModelo.substring((valorModelo.length - 2), valorModelo.length) : valorModelo
                valorFabrica = valorFabrica.length > 2 ? valorFabrica.substring((valorFabrica.length - 2), valorFabrica.length) : valorFabrica

                // SETA O NOVO VALOR RECEBIDO
                linha.valueApi =  valorFabrica.trim() + '/' + valorModelo.trim()
                break

              default:
                linha.valueApi = '-'
                break
            }
          } else if (self.cpntDadosApi.hasOwnProperty(self.cpntCampos[key].keyApi)) {
            linha.valueApi = self.cpntDadosApi[self.cpntCampos[key].keyApi]
          } else {
            linha.valueApi = '-'
          }

          if ((linha.campo !== 'cnae' && linha.valueForm !== linha.valueApi) || (linha.campo === 'cnae' && ((linha.valueForm[0].valores.aRamIds.join() !== linha.valueApi[0].valores.aRamIds.join()) || linha.valueForm[0].valores.p !== linha.valueApi[0].valores.p))) {
            if (self.cpntCampos[key].hasOwnProperty('acao')) {
              for (var key2 in self.cpntCampos[key].acao) {
                linha.acao[0].options[key2].disabled = self.cpntCampos[key].acao[key2]
              }
            }

            if ([ 'email' ].indexOf(self.cpntCampos[key].keyApi) !== -1) {
              linha.acao[0].value = '1'
              linha.rfClass = 'rf-busca-api-tipo-1'
            } else {
              linha.rfClass = 'rf-busca-api-tipo-2'
            }

            if (linha.valueForm === '') {
              self.tabela.contaValorBranco = self.tabela.contaValorBranco + 1
            }

            // ADICIONA A LINHA NA TABELA
            self.tabela.linha.push(linha)
          } else if (linha.campo === 'cnae') {
            self.buscarCnae = []
          }
        }

        // REMOVE CLASSES DUPLICADAS
        self.buscarCnae = self.buscarCnae.filter((v, i, a) => a.indexOf(v) === i)

        if (self.tabela.linha.length === 0) {
          // APRESENTA A MENSAGEM DE ADVERTENCIA
          self.$store.state.msgWarn('Todos os dados solicitados já estão preenchidos no formulário. Nenhuma alteração encontrada.', 'warning')

          switch (self.cpntTipo) {
            case 'contato':
              // APRESENTA MENSAGEM DE ERRO NOVAMENTE PARA O CLIENTE
              if (self.cpntDadosApi.situacao !== 'ATIVA') {
                self.$store.state.msgWarn('Informação importante: Em nosso cadastro este CNPJ consta como ' + self.cpntDadosApi.situacao + '.', 'warning')
              }
              break

            case 'veiculo':
              // APRESENTA MENSAGEM DE ERRO NOVAMENTE PARA O CLIENTE
              if (self.cpntDadosApi.codigoSituacao !== '0') {
                self.$store.state.msgWarn('Informação importante: Veículo com a seguinte situação "' + self.cpntDadosApi.situacao + '".', 'warning')
              }
              break
          }

          // CHAMA A FUNÇÃO PARA FECHAR
          self.onFecharVisualizacao(false)
        } else {
          switch (self.cpntTipo) {
            case 'contato':
              if (self.cpntDadosApi.situacao !== 'ATIVA') {
                self.tabela.fraseTop = [ '<div style="color: #f00; font-size: var(--font-base-soma-12); font-weight: bold; text-align: center;">Informação importante: Em nosso cadastro este CNPJ consta como ' + self.cpntDadosApi.situacao + '.</div>' ]
              }
              break
          }

          // FAZ A MONTAGEM DAS INFORMAÇÕES PARA TABELA
          self.$store.state.FUN_TABELA_CRIAR_DADOS(self.tabela, function (tabelaSuccess) {
            // SETA OS VALORES RECEBIDOS
            self.tabela = tabelaSuccess

            // ADICIONA O QTIP AO CAMPO SE ELE EXISTIR
            setTimeout(function () {
              $('span.radio-check-value-api').qtip({
                position: {
                  my: 'top right',
                  at: 'bottom left'
                },
                style: {
                  classes: 'rf-qtip'
                }
              })
            }, 1000)

            // CHAMA A FUNÇÃO PARA TRATAR OS VALORES
            self.tratarValorTabelaVerificacao()
          })
        }
      },
      tratarValorTabelaVerificacao: function () {
        if (this.buscarCnae.length === 0) {
          this.finalizarTabelaVerificacao()
        } else {
          var self = this
          var key = ''

          // CRIA O QUERY GET QUE SERÁ REALIZADO NA API
          var queryGet = { type: 'list', field: { cnae: null, nome: null }, where: { f: 'cnae', o: 'in', v: self.buscarCnae.join() }, limit: { row: 0, qty: 1000 } }

          // CHAMA A FUNÇÃO PARA FINALIZAR O FORMULARIO
          self.$store.state.comunicaAPI('/referencia/cnae/get/', 'GET', queryGet, function (apiSuccess) {
            var indexL = self.tabela.linha.findIndex(item => item.campo === 'cnae')

            // SETA OS VALORES DA TABELA DE CNAE
            self.tabela.linha[indexL].valueForm[0].linha = apiSuccess.data.filter(item => self.tabela.linha[indexL].valueForm[0].valores.aRamIds.indexOf(item.cnae) !== -1)
            self.tabela.linha[indexL].valueApi[0].linha = apiSuccess.data.filter(item => self.tabela.linha[indexL].valueApi[0].valores.aRamIds.indexOf(item.cnae) !== -1)

            // FAZ A MONTAGEM DAS INFORMAÇÕES PARA TABELA
            self.$store.state.FUN_TABELA_CRIAR_DADOS(JSON.parse(JSON.stringify(self.tabela.linha[indexL].valueForm[0])), function (tabelaSuccess1) {
              for (key in tabelaSuccess1.linha) {
                if (!tabelaSuccess1.colqtip.hasOwnProperty(key)) {
                  tabelaSuccess1.colqtip[key] = []
                }

                tabelaSuccess1.colqtip[key].push({
                  coluna: 'cnae',
                  mensagem: tabelaSuccess1.linha[key].nome
                })

                if (tabelaSuccess1.valores.hasOwnProperty('p') && tabelaSuccess1.valores.p === tabelaSuccess1.linha[key].cnae) {
                  tabelaSuccess1.linha[key].cnae = tabelaSuccess1.linha[key].cnae + ' <b>(Principal)</b>'
                } else {
                  tabelaSuccess1.linha[key].cnae = tabelaSuccess1.linha[key].cnae
                }
              }

              // SETA OS VALORES RECEBIDOS
              self.tabela.linha[indexL].valueForm[0] = tabelaSuccess1

              // FAZ A MONTAGEM DAS INFORMAÇÕES PARA TABELA
              self.$store.state.FUN_TABELA_CRIAR_DADOS(JSON.parse(JSON.stringify(self.tabela.linha[indexL].valueApi[0])), function (tabelaSuccess2) {
                for (key in tabelaSuccess2.linha) {
                  if (!tabelaSuccess2.colqtip.hasOwnProperty(key)) {
                    tabelaSuccess2.colqtip[key] = []
                  }

                  tabelaSuccess2.colqtip[key].push({
                    coluna: 'cnae',
                    mensagem: tabelaSuccess2.linha[key].nome
                  })

                  if (tabelaSuccess2.valores.hasOwnProperty('p') && tabelaSuccess2.valores.p === tabelaSuccess2.linha[key].cnae) {
                    tabelaSuccess2.linha[key].cnae = tabelaSuccess2.linha[key].cnae + ' <b>(Principal)</b>'
                  }
                }

                // SETA OS VALORES RECEBIDOS
                self.tabela.linha[indexL].valueApi[0] = tabelaSuccess2

                // CHAMA A FUNÇÃO PARA TRATAR OS VALORES
                self.finalizarTabelaVerificacao()
              }, function (tabelaError2) {
                // SETA OS VALORES RECEBIDOS
                self.tabela.linha[indexL].valueApi[0].status = tabelaError2

                // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
                self.time = new Date().getTime()
              })
            }, function (tabelaError1) {
              // SETA OS VALORES RECEBIDOS
              self.tabela.linha[indexL].valueForm[0].status = tabelaError1

              // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
              self.time = new Date().getTime()
            })
          }, function (apiError) {
            // SETA O STATUS
            self.statusGeral = apiError

            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            self.time = new Date().getTime()
          })
        }
      },
      finalizarTabelaVerificacao: function () {
        var self = this

        self.$store.state.FUN_CREATE_BUTTON_FORM((self.tabela.id + '-bt-atu-campo'), [ '2' ], null, {
          env: function () {
            var campoAcao = {}
            for (var key in self.tabela.linha) {
              campoAcao[self.tabela.linha[key].campo] = self.tabela.linha[key].acao[0].value
            }

            for (var key2 in self.cpntCampos) {
              if ([ '', null, undefined ].indexOf(self.cpntCampos[key2].converteApi) === -1 && self.cpntCampos[key2].converteApi.tipo === 'radio') {
                if ([ '', null, undefined ].indexOf(campoAcao[self.cpntCampos[key2].keyForm]) === -1 && campoAcao[self.cpntCampos[key2].keyForm] === '2') {
                  var dados = self.cpntDadosApi[self.cpntCampos[key2].keyApi]
                  if (dados.length >= 2) {
                    var radio = document.querySelector('input[name="radio-check-value-api-' + self.cpntCampos[key2].keyApi + '"]:checked')
                    if (radio !== null) {
                      campoAcao[self.cpntCampos[key2].keyForm] = radio.value;
                    } else {
                      campoAcao[self.cpntCampos[key2].keyForm] = '0';
                    }
                  } else if (dados.length === 1) {
                    campoAcao[self.cpntCampos[key2].keyForm] = self.cpntDadosApi[self.cpntCampos[key2].keyApi][0].IE;
                  }
                }
              }
            }

            // SETA OS STATUS DO BUTTON
            self.buttons.env.status = 'carregando'

            // CHAMA A FUNÇÃO PARA FECHAR O FORMULARIO
            self.onFecharVisualizacao(true, campoAcao)
          },
          can: function () {
            self.onFecharVisualizacao(false)
          }
        }, function (buttons) {
          // SETA O NOVO NOME PARA O BOTÃO ATUALIZAR
          buttons.env.texto = 'Copiar'

          // SETA OS BOTÕES RECEBIDOS
          self.buttons = buttons

          if (self.tabela.contaValorBranco === self.tabela.linha.length) {
            self.buttons.env.onClick()
          } else {
            // SETA O STATUS PARA TABELA
            self.tabela.status = ''

            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            self.time = new Date().getTime()
          }
        })
      },
      onFecharVisualizacao: function (atualizar, campos = {}) {
        this.cpntOnFecharFormulario(atualizar, campos)
      },
      onCheckboxAtualiza: function (coluna = null, checkbox = null) {
        if (coluna !== null && checkbox !== null) {
          var self = this

          // PEGA O ID DA COLUNA
          var indexColuna = self.tabela.coluna.findIndex(item => item.chave === coluna)

          // SETA O VALOR RECEBIDO NO CHECKBOX
          self.checkbox[coluna] = checkbox.filter(item => item !== self.tabela.coluna[indexColuna].chave)

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          self.time = new Date().getTime()
        }
      },
      onChangeValueTabela: function (value, id) {
        // PEGA O NOME DO CAMPO QUE ESTA SENDO ALTERADO
        var index = id.split('--')

        // SETA O VALOR RECEBIDO
        this.tabela.linha[index[1]][index[2]][index[3]].value = value

        // REMOVE A MENSAGEM DE ERRO
        this.tabela.linha[index[1]][index[2]][index[3]].mensagem = ''
        this.tabela.linha[index[1]][index[2]][index[3]].mensagemTipo = ''

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()

        switch (index[2]) {
          case 'acao':
            this.tabela.linha[index[1]].rfClass = 'rf-busca-api-tipo-' + value
            break
        }
      }
    }
  }
</script>
